import "./../scss/main.scss";
import "./../scss/solutions.scss";

import "bootstrap";
